import api from "../../services/api";

// ===============================
// Get All Notifications
// ===============================
export const getNotifications = async () => {
  const response = await api.get("/user-notifications");
  return response.data;
};

// ===============================
// Get Unread Count
// ===============================
export const getUnreadCount = async () => {
  const response = await api.get(
    "/user-notifications/unread-count"
  );

  return response.data;
};

// ===============================
// Mark Notification Read
// ===============================
export const markNotificationRead = async (id) => {
  const response = await api.put(
    `/user-notifications/${id}/read`
  );

  return response.data;
};

// ===============================
// Mark All Read
// ===============================
export const markAllNotificationsRead = async () => {
  const response = await api.put(
    "/user-notifications/mark-all-read"
  );

  return response.data;
};

// ===============================
// Delete Notification
// ===============================
export const deleteNotification = async (id) => {
  const response = await api.delete(
    `/user-notifications/${id}`
  );

  return response.data;
};